<app-historical-readouts-card [readoutNumber]="currentReadoutNumber"></app-historical-readouts-card>
  